import { useEffect, useState } from "react";
import { Input } from "design-react-kit";
import ModalComponent from "./ModalComponent";

function DuplicateAnnouncementModal({ isOpen, toggleModal, onConfirm, loading }) {
  const currentYear = new Date().getFullYear();
  const [codAccertamento, setCodAccertamento] = useState("");
  const [year, setYear] = useState(currentYear);
  const [validation, setValidation] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (isOpen) {
      setCodAccertamento("");
      setYear(currentYear);
      setValidation(false);
      setErrorMessage("");
    }
  }, [isOpen, currentYear]);

  const confirm = () => {
    if (loading) return;

    setValidation(true);
    setErrorMessage("");

    const yearValue = parseInt(year, 10);
    if (!codAccertamento || !codAccertamento.trim()) return;
    if (isNaN(yearValue) || yearValue < 2000 || yearValue > 2100) return;

    onConfirm(
      {
        codAccertamento: codAccertamento.trim(),
        year: yearValue,
      },
      (message) => setErrorMessage(message)
    );
  };

  return (
    <ModalComponent
      toggleModal={toggleModal}
      isOpen={isOpen}
      header="Duplica bando"
      body={
        <>
          <p>
            Inserisci il codice Accertamento e l&apos;anno del nuovo bando. Verranno
            copiate le fasce ISEE e gli utenti iscritti. Il bando sarà creato in
            stato <b>Creato</b>.
          </p>
          {errorMessage && (
            <div className="alert alert-danger" role="alert">
              {errorMessage}
            </div>
          )}
          <div className="row">
            <div className="col-lg-8">
              <Input
                id="duplicaCodAccertamento"
                label="Codice Accertamento*"
                type="text"
                name="codAccertamento"
                value={codAccertamento}
                onChange={(e) => setCodAccertamento(e.target.value)}
                {...(validation &&
                  !codAccertamento.trim() && {
                    infoText: "Il campo non può essere vuoto!",
                    className: "text-danger error_div is-invalid",
                  })}
              />
            </div>
            <div className="col-lg-4">
              <Input
                id="duplicaAnno"
                label="Anno*"
                type="number"
                name="year"
                value={year}
                onChange={(e) => setYear(e.target.value)}
                {...(validation &&
                  (isNaN(parseInt(year, 10)) ||
                    parseInt(year, 10) < 2000 ||
                    parseInt(year, 10) > 2100) && {
                    infoText: "Inserire un anno valido!",
                    className: "text-danger error_div is-invalid",
                  })}
              />
            </div>
          </div>
        </>
      }
      buttonConfirm={loading ? "Duplicazione..." : "Conferma"}
      buttonDeny="Annulla"
      function={confirm}
    />
  );
}

export default DuplicateAnnouncementModal;
